import { Link, Text } from '@chakra-ui/react';
import { BiLink } from 'react-icons/bi';

type TBinanceOption = 'tx' | 'address' | 'block'

interface TPropsLinkBinance {
  transaction: string
  option?: TBinanceOption
  text?: string,
  textPrev?: string,
  className?: string
}

const LinkBinance = (props: TPropsLinkBinance) => {
  const { transaction, option = 'tx', text, textPrev, className } = props
  const isProduction = process.env.NEXT_PUBLIC_NODE_ENV != "development"
  return (
    <span>
      {textPrev && `${textPrev} `}
      <Link
        className={className}
        target='_blank'
        href={`https://${isProduction ? '' : 'testnet.'}bscscan.com/${option}/${transaction}`}
      >
        {!text
          ? (
            <Text display={'inline-block'}>
              {transaction.slice(0, 6)}...{transaction.slice(transaction.length - 6, transaction.length)}
            </Text>
          )
          : (
            <Text display={'inline-block'}>{text}</Text>
          )
        }
        <Text display={'inline-block'}>
          <BiLink />
        </Text>
      </Link>
    </span >
  );
};

export default LinkBinance;